import store from "@/store";
import { getEnvironmentTitle } from "./environment";

const baseTitle = "Qfs-Console";

const getBreadcrumbNames = () => {
  return (store.state.appBar?.breadcrumbs || [])
    .slice(0, 2)
    .map(breadcrumb => breadcrumb.text)
    .filter(Boolean);
};

export const setPageTitle = region => {
  const titleParts = [baseTitle];
  const breadcrumbs = getBreadcrumbNames();
  const environmentTitle = getEnvironmentTitle();

  if (breadcrumbs.length) {
    titleParts.push(breadcrumbs.join(" - "));
  }

  if (environmentTitle) {
    titleParts.push(environmentTitle);
  }

  if (region) {
    titleParts.push(region);
  }

  document.title = titleParts.join(" | ");
};
